<ion-content>

  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button (click)="close()" fill="clear" color="dark" class="ion-no-padding">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData.dark_logo[0]"></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">

    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1><b>{{'My Credit Cards' | translate}}</b></h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="creditCards">
      <ion-col size="12" *ngFor="let card of creditCards; let i = index">
        <ion-card>
          <ion-grid>
            <ion-row>

              <ion-col size="8">
                <ion-card-header>
                  <ion-card-title>{{card.cardName}}</ion-card-title>
                  <ion-card-subtitle color="primary">
                    {{card.cardHolderName}}
                  </ion-card-subtitle>

                  <ion-text color="dark">
                    **** **** **** {{card.cardNo | slice:12:16}}
                  </ion-text> <br>


                  <ion-text color="dark">
                    {{card.month}}/{{card.year}}
                  </ion-text>
                </ion-card-header>
              </ion-col>

              <ion-col size="4" class="right">
                <ion-button (click)="deleteCard(i)" color="danger" fill="clear">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
                <!-- <img src="assets/img/logo-outline.svg"> -->
              </ion-col>

            </ion-row>
          </ion-grid>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="!creditCards || creditCards.length === 0">
      <ion-col size="12" class="no-card">

        <div class="svg"></div>

        <ion-text color="primary">
          {{'Dear guest, you can add your credit card to make your transactions quickly and for your payments.' |
          translate}}
        </ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-row>
  <ion-col size="12" class="bottom-button">
    <ion-button expand="block" color="primary" (click)="addNew()">
      {{'Add New Card' | translate}}
    </ion-button>
  </ion-col>
</ion-row>